import { Injectable } from '@angular/core';
import * as  packageJson from '../../../package.json';
import {SettingsService} from "./settings.service";
import {ModalService} from "./modal.service";
import {translation} from "../translation";

@Injectable({
  providedIn: 'root'
})
export class InfoMessageService {

  /* These properties must be set in tsconfig.json in order to read the package.json file:
  * "resolveJsonModule": true
  * "allowSyntheticDefaultImports": true
  */
  public version: string = packageJson.version;

  public messages: string[] | null | undefined = translation.info_messages;

  constructor(private settingService: SettingsService,
              private modalService: ModalService) {}

  async checkForInfoMessage() {
    await this.settingService.loadSettings();

    const lastVersion = await this.settingService.getVersion();

    if (lastVersion !== this.version) {
      await this.settingService.setVersion(this.version);
      if(this.messages) {
        this.modalService.openDialog('whats-new', {messages: this.messages, version: this.version});
      }
    }
  }
}
